<template>
  <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition" v-model="detailReportDialog">
    <v-app-bar dark color="primary">
      <v-btn icon dark @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title class="text-capitalize font-weight-bold">{{ empData.name }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn class="ma-2" @click="print()" rounded small dark outlined>PRINT</v-btn>
      <Create :appbar="true" v-if="employeeAccess && employeeAccess.timeClock.create" @submit="dataSave"
        @error="dataError" :employee="empData" />

    </v-app-bar>
    <v-card>
      <div>
        <!-- <v-app-bar elevation="0" color="white" app>
      <v-btn @click="backToReport" text icon color="primary">
        <v-icon>mdi-arrow-left-thin-circle-outline</v-icon>
      </v-btn>
      <div class="text-capitalize">Detailed Report</div>

      <v-spacer></v-spacer>
      <Create
        v-if="employeeAccess && employeeAccess.timeClock.create"
        @submit="dataSave"
        @error="dataError"
        :employee="empData"
      />
    </v-app-bar> -->
        <v-divider></v-divider>
        <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
        <!-- <v-subheader style="height: 40px" class="mb-2">
      <v-icon @click="$router.go(-1)" class="pr-2"
        >mdi-arrow-left-thin-circle-outline</v-icon
      >
      <h4>Detailed Report</h4>
    </v-subheader> -->
        <v-container class="mt-2">
          <!-- <v-row v-if="empData" class="px-5 mb-3 caption" align-content="center" justify="space-between">
            <v-col cols="9" class="pa-0">
              <v-flex>
                <h3 class="text-left text-capitalize">{{ empData.name }}</h3>
                <span>{{ empData.phoneNumber }}</span>
              </v-flex>
              <v-flex v-if="employeeAccess && employeeAccess.report.showPay && empData.metadata.timeClockLogin && empData.metadata.timeClockLogin.fullDayEmployee">
                <span v-if="empData.metadata.timeClockLogin.fullDayRate" >Rate: {{ empData.metadata.timeClockLogin.fullDayRate | currency }}</span>
                <span v-else >Rate: {{ 0 | currency }}</span>
              </v-flex>
              <v-flex v-else-if="employeeAccess && employeeAccess.report.showPay">
                <span>Rate: {{ empData.hourlyRate | currency }}</span>
              </v-flex>
              <v-flex>
                <span>From: {{ dateTime.start | moment("ddd L") }}</span>
              </v-flex>
              <v-flex>
                <span>To: {{ dateTime.end | moment("ddd L") }}</span>
              </v-flex>
              <v-flex>
                <span>Daily Working Hours: {{ workingHours }} Hr</span>
              </v-flex>


              <v-flex v-if="employeeAccess && employeeAccess.report.showHours">
                <span>Worked Hours </span>
                <strong>{{ secondsToHms(totalSeconds) }}</strong>
              </v-flex>
              <div>
                <v-flex>
                  <span>Supposed To Work </span>
                  <span>{{ secondsToHms(workingSeconds()) }}</span>
                </v-flex>
                <v-flex v-if="diffTime() > 0">
                  <v-chip label color="red" small text-color="white">
                    Short: {{ secondsToHms(diffTime()) }}
                  </v-chip>
                </v-flex>
                <v-flex v-else>
                  <v-chip label color="green" small text-color="white">
                    Over: {{ secondsToHms(Math.abs(diffTime())) }}
                  </v-chip>
                </v-flex>
              </div>
            </v-col>
            <v-col cols="3" class="pa-0 text-right" v-if="employeeAccess && employeeAccess.report.showPay">
              <v-layout column fill-height align-content-space-around>
                <v-flex>
                  <v-layout column>
                    <v-flex>
                      <h3>{{ grandTotal_total | currency }}</h3>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex shrink v-if="employeeAccess && employeeAccess.pay.create">

                  <CreatePay v-if="showPayBtn && !loading" @submit="savePayment" @error="dataError"
                    :workingSeconds="workingSeconds()" :employee="empData" :grandTotal="grandTotal_total"
                    :period="dateTime" :totalSeconds="totalSeconds" />
                </v-flex>
              </v-layout>
            </v-col>
          </v-row> -->

          <v-row v-if="empData" class="px-5 mb-3 caption" align-content="center" justify="space-between">

            <!-- Left Side: Employee Details -->
            <v-col cols="6" class="pa-0">
              <v-flex>
                <h3 class="text-left text-capitalize">{{ empData.name }}</h3>
                <span>{{ empData.phoneNumber }}</span>
              </v-flex>

              <!-- Hourly or Full-Day Rate -->
              <v-flex
                v-if="employeeAccess && employeeAccess.report.showPay && empData.metadata.timeClockLogin && empData.metadata.timeClockLogin.fullDayEmployee">
                <span v-if="empData.metadata.timeClockLogin.fullDayRate">
                  Rate: {{ empData.metadata.timeClockLogin.fullDayRate | currency }}
                </span>
                <span v-else>Rate: {{ 0 | currency }}</span>
              </v-flex>
              <v-flex v-else-if="employeeAccess && employeeAccess.report.showPay">
                <span>Hourly Rate: <strong>{{ empData.hourlyRate | currency }}</strong></span>
              </v-flex>

              <!-- Date Time Period -->
              <v-flex>
                <span>From: {{ dateTime.start | moment("ddd L") }}</span>
              </v-flex>
              <v-flex>
                <span>To: {{ dateTime.end | moment("ddd L") }}</span>
              </v-flex>

              <!-- Daily Working Hours -->
              <v-flex>
                <span>Daily Working Hours: <strong>{{ workingHours }} Hr</strong></span>
              </v-flex>

              <!-- Worked Hours -->
              <v-flex v-if="employeeAccess && employeeAccess.report.showHours">
                <span>Worked Hours: </span>
                <strong>{{ secondsToHms(totalSeconds) }}</strong>
              </v-flex>

              <!-- Worked vs Supposed to Work -->
              <div>
                <v-flex>
                  <span>Supposed To Work: </span>
                  <span>{{ secondsToHms(workingSeconds()) }}</span>
                </v-flex>
                <v-flex v-if="diffTime() > 0">
                  <v-chip label color="red" small text-color="white">
                    Short: {{ secondsToHms(diffTime()) }}
                  </v-chip>
                </v-flex>
                <v-flex v-else>
                  <v-chip label color="green" small text-color="white">
                    Over: {{ secondsToHms(Math.abs(diffTime())) }}
                  </v-chip>
                </v-flex>
              </div>
            </v-col>

            <!-- Right Side: Overtime & Pay Details -->
            <v-col cols="6" class="pa-0 text-right" v-if="employeeAccess && employeeAccess.report.showPay">
              <v-layout column fill-height align-content-space-around>

                <!-- Overtime Section -->
                <v-flex v-if="empData.payOverTime">
                  <v-chip label color="blue" small text-color="white">
                    Overtime Active
                  </v-chip>
                  <v-flex>
                    <span>Overtime Starts After: <strong>{{ empData.startOverTime }} Hours</strong></span>
                  </v-flex>
                  <v-flex v-if="overtimeHours > 0">
                    <span>Overtime Hours: <strong>{{ secondsToHms(overtimeHours) }}</strong></span>
                  </v-flex>
                  <v-flex>
                    <span>Overtime Rate: <strong>{{ empData.overTimeRate | currency }}</strong></span>
                  </v-flex>
                </v-flex>

                <!-- Pay Breakdown -->
                <v-flex>
                  <v-layout column>
                    <v-flex>
                      <h3>Regular Pay: <strong>{{ regularPay | currency }}</strong></h3>
                    </v-flex>
                    <v-flex v-if="empData.payOverTime && overtimeHours > 0">
                      <h3>Overtime Pay: <strong>{{ overtimePay | currency }}</strong></h3>
                    </v-flex>
                    <v-flex>
                      <h2>Total Pay: <strong>{{ totalPayWithOvertime | currency }}</strong></h2>
                    </v-flex>
                  </v-layout>
                </v-flex>

                <!-- Pay Button -->
                <v-flex shrink v-if="employeeAccess && employeeAccess.pay.create">
                  <CreatePay v-if="showPayBtn && !loading" @submit="savePayment" @error="dataError"
                    :workingSeconds="workingSeconds()" :employee="empData" :grandTotal="totalPayWithOvertime"
                    :overtimeHours="overtimeHours" :regularHours="regularHours" :regularPay="regularPay"
                    :overtimePay="overtimePay" :totalPayWithOvertime="totalPayWithOvertime" :period="dateTime"
                    :totalSeconds="totalSeconds" />
                </v-flex>

              </v-layout>
            </v-col>
          </v-row>

          <v-card flat outlined class="touch-view-container">
            <v-list dense>
              <template v-for="(row, i) in Object.keys(unGroupList)">
                <v-list-item @click.stop.prevent="
                  openDetail(Object.entries(unGroupList)[i][1])
                  ">
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-row align="center">
                        <v-col>{{
                          Object.entries(unGroupList)[i][1].row[0].clockInTime
                          | moment("dddd")
                        }}
                          - {{ row }}
                        </v-col>
                        <v-col class="shrink">{{
                          Object.entries(unGroupList)[i][1].row.length
                        }}</v-col>
                      </v-row>
                    </v-list-item-title>

                    <v-progress-linear :color="barColor(Object.entries(unGroupList)[i][1])" height="25" :value="duration(
                      Object.entries(unGroupList)[i][1].totalInSeconds,
                      Object.entries(unGroupList)[i][1].metadata
                    )
                      " striped>

                    </v-progress-linear>
                    <v-list-item-subtitle>
                      <v-row align="center">
                        <v-col v-if="Object.entries(unGroupList)[i][1].row[0]
                          .TimeClockPayId
                        " class="shrink pr-0">
                          <v-chip label small style="height: 20px; font-size: 10px" text-color="white"
                            color="red">Paid</v-chip>
                        </v-col>

                        <v-col v-if="employeeAccess && employeeAccess.report.showHours">
                          {{
                            secondsToHms(
                              Object.entries(unGroupList)[i][1].totalInSeconds
                            )
                          }}
                          <span v-if="Object.entries(unGroupList)[i][1].astrid" class="red--text">* <strong>Not counted
                              in
                              pay!</strong></span>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col class="text-right" v-if="Object.entries(unGroupList)[i][1].early">
                          <span class="red--text">{{
                            secondsToHms(Object.entries(unGroupList)[i][1].early)
                          }}</span>
                        </v-col>
                      </v-row>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-divider v-if="i + 1 < Object.keys(unGroupList).length" :key="i"></v-divider>
              </template>
            </v-list>
          </v-card>
          <DayDetail @submit="dataSave" @close="dialog = false" :dialog="dialog" :selectedRow="selectedRow" />
        </v-container>
      </div>
    </v-card>
    <v-dialog v-model="showPdf" width="700">
      <v-card style="height: 800px">
        <v-toolbar class="elevation-0">
          <v-toolbar-title class="subheading">Time Card</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.stop.prevent="showPdf = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-layout fill-height column>
          <embed id="embedPDF" :src="pdf" type="application/pdf" height="100%" width="100%" />
        </v-layout>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import timeClockService from "@/modules/TimeClock/service";
import DayDetail from "@/modules/Reports/components/DayDetail.vue";
// import employeeService from "@/modules/Employee/service";
import DateTimeTextField from "@/components/DateTimeTextField.vue";
import locationService from "@/modules/Location/service.js";
import DateTimePicker from "@/components/DateTimePicker.vue";
import Create from "@/modules/Reports/components/Create.vue";
import CreatePay from "@/modules/Pay/components/Create.vue";
import authService from "@/modules/Authentication/service.js";
import pdfMake from 'pdfmake/build/pdfmake.min';
import { pdfMake as pdfFonts } from 'pdfmake/build/vfs_fonts';
// import Menu from "@/components/AppBarMenu.vue";

import _ from "lodash";
import { mapGetters } from "vuex";

pdfMake.vfs = pdfFonts.vfs;
export default {
  props: ["EmployeeId", "empData", "dateTime", "mainDialog"],
  data() {
    return {
      detailReportDialog: false,
      reload: false,
      integration: null,
      workingHours: 12,
      locationCode: null,
      showPayBtn: true,
      editDialog: false,
      editRow: null,
      selectedRow: null,
      dialog: false,
      totalSeconds: 0,
      unGroupList: [],
      loading: false,
      selectedEmployees: [],
      employees: [],
      timeClockList: [],
      totalTime: 0,
      count: 0,
      doc: {
        content: []
      },
      location: null,
      pdf: null,
      showPdf: false,
      metadata: {
        customClockIn: {
          storeTimeClockImage: false,
          defaultWorkingHours: 12,
          storeTimeClockImageView: false,
        },
      },
    };
  },
  components: {
    DayDetail,
    DateTimePicker,
    DateTimeTextField,
    CreatePay,
    Create,
  },
  // activated() {
  //   this.locationCode = localStorage.getItem(
  //     `${process.env.VUE_APP_STORAGE_PREFIX}code`
  //   );
  //   if (
  //     this.$route.params.id &&
  //     this.$route.params &&
  //     this.$route.params.dateTime
  //   ) {
  //     const id = this.$route.params.id;
  //     this.EmployeeId = id;
  //     this.empData = this.$route.params.empData;
  //     this.dateTime = this.$route.params.dateTime;
  //     this.loadTimeClock();
  //     // console.log("dateTime", this.$route.params);
  //   } else {
  //     this.$router.push({ name: "hours-summary" });
  //   }
  //   this.loadSetting();
  //   // console.log('this.empData', this.empData)
  // },
  computed: {
    ...mapGetters("employee", ["employeeAccess"]),
    totalWorkedHours() {
      return this.totalSeconds / 3600; // Convert total seconds to hours
    },
    regularHours() {
      // If overtime is NOT enabled, all hours are regular hours
      if (!this.empData.payOverTime) {
        return this.totalWorkedHours;
      }

      // If total hours are less than overtime start time, return total hours worked
      if (this.totalWorkedHours <= this.empData.startOverTime) {
        return this.totalWorkedHours;
      }

      // Otherwise, cap regular hours at startOverTime (default 40)
      return Math.min(this.totalWorkedHours, this.empData.startOverTime);
    },
    overtimeHours() {
      // Ensure overtime applies only if payOverTime is true and total hours exceed startOverTime
      if (!this.empData.payOverTime) {
        return 0; // No overtime if payOverTime is false
      }

      // Calculate overtime in hours first
      const overtimeInHours = Math.max(0, this.totalWorkedHours - this.empData.startOverTime);

      // Convert overtime hours to seconds (1 hour = 3600 seconds)
      return overtimeInHours * 3600;
    },
    regularPay() {
      // Ensure it always returns a value
      console.log('regularHours', this.regularHours)
      return this.regularHours * (this.empData.hourlyRate || 0);
    },
    // overtimePay() {
    //   // Ensure it returns 0 if overtime is not active
    //   return this.empData.payOverTime ? this.overtimeHours * (this.empData.overTimeRate || 0) : 0;
    // },
    overtimePay() {
      // Ensure overtime applies only if payOverTime is true
      if (!this.empData.payOverTime) {
        return 0;
      }

      // Convert overtime rate from hourly to per-second rate
      const overtimeRatePerSecond = (this.empData.overTimeRate || 0) / 3600;

      // Calculate overtime pay based on worked overtime seconds
      return this.overtimeHours * overtimeRatePerSecond;
    },
    totalPayWithOvertime() {
      // Total should always be the sum of regular and overtime pay
      return this.regularPay + this.overtimePay;
    },
    grandTotal_total() {
      if (this.empData.metadata && this.empData.metadata.timeClockLogin && this.empData.metadata.timeClockLogin.fullDayEmployee) {
        const totalHoursByDate = {};
        let totalCash = 0;
        this.timeClockList.forEach((row) => {
          if (row.clockOutTime) {
            const date = this.$moment(row.clockOutTime).format('YYYY-MM-DD');
            const totalHours = parseFloat(row.shiftDuration.totalInHours);
            // Check if the date already exists in the totalHoursByDate object
            if (totalHoursByDate[date]) {
              totalHoursByDate[date] += totalHours;
            } else {
              // If it doesn't exist, create a new entry with the total hours value
              totalHoursByDate[date] = totalHours;
            }
          }
        });
        Object.entries(totalHoursByDate).forEach(([totalHours]) => {
          // console.log("date ", date)
          if (this.empData.metadata.timeClockLogin && totalHours >= parseInt(this.empData.metadata.timeClockLogin.workingHours)) {
            totalCash += this.empData.metadata.timeClockLogin.fullDayRate ? parseFloat(this.empData.metadata.timeClockLogin.fullDayRate) : 0;
          } else if (this.empData.metadata.timeClockLogin && totalHours >= parseInt(this.empData.metadata.timeClockLogin.halfDayHours)) {
            totalCash += this.empData.metadata.timeClockLogin.fullDayRate ? parseFloat(this.empData.metadata.timeClockLogin.fullDayRate) / 2 : 0;
          }
        });
        return totalCash;
      }
      let totalHours = 0;
      this.timeClockList.map((row) => {
        if (row.clockOutTime) {
          totalHours += parseFloat(row.shiftDuration.totalInHours);
        }
      });
      return totalHours * this.empData.hourlyRate;
    },
  },
  created() {
    let localLocation = localStorage.getItem(
      `${process.env.VUE_APP_STORAGE_PREFIX}location`
    );


    if (localLocation) {
      localLocation = JSON.parse(localLocation);

      locationService.Terminal.getById(localLocation.id).then(response => {
        this.location = response.data
        if (this.location && this.location.metadata && this.location.metadata.isLocked) {
          this.$router.push({
            name: "no-subscription",
            params: {
              location: this.Location,
            },
          });
        }
      })
      this.detailReportDialog = true
      this.loadTimeClock();
      this.loadSetting();
    }
  },
  watch: {
    mainDialog(val) {
      this.detailReportDialog = val;
      if (val) {
        this.loadTimeClock();
        this.loadSetting();
      }
    },
    empData(val) {
      // console.log("val emp change", val);
      if (
        val.metadata &&
        val.metadata.timeClockLogin &&
        val.metadata.timeClockLogin.workingHours
      ) {
        // console.log("in here");
        this.workingHours = val.metadata.timeClockLogin.workingHours;
      }
    },
  },
  methods: {
    print() {
      this.showPdf = true
    },
    async createDocument() {
      this.doc.content = [];

      // Location Header
      if (this.location) {
        this.doc.content.push({
          text: this.location.name,
          alignment: 'center',
          fontSize: 15,
        });
      }

      // Time Card Header
      this.doc.content.push({
        text: "Time Card",
        alignment: 'center',
        fontSize: 15,
      });

      // Employee Details
      this.doc.content.push({
        text: this.empData.name,
        alignment: 'left',
        fontSize: 15,
      });
      this.doc.content.push({
        text: this.empData.phoneNumber,
        alignment: 'left',
      });

      // Pay Rate (if applicable)
      if (this.employeeAccess && this.employeeAccess.report.showPay) {
        this.doc.content.push({
          text: 'Rate: $' + this.empData.hourlyRate,
          alignment: 'left',
        });
      }

      // Date Range
      this.doc.content.push({
        text: 'From: ' + this.$moment(this.dateTime.start).format('ddd MM/DD/YYYY'),
        alignment: 'left',
      });
      this.doc.content.push({
        text: 'To: ' + this.$moment(this.dateTime.end).format('ddd MM/DD/YYYY'),
        alignment: 'left',
      });

      // Working Hours
      this.doc.content.push({
        text: 'Daily Working Hours: ' + this.workingHours + ' Hr',
        alignment: 'left',
      });

      // Worked Hours
      if (this.employeeAccess && this.employeeAccess.report.showHours) {
        this.doc.content.push({
          text: 'Worked Hours: ' + this.secondsToHms(this.totalSeconds),
          alignment: 'left',
        });
      }

      // Supposed to Work
      this.doc.content.push({
        text: 'Supposed To Work: ' + this.secondsToHms(this.workingSeconds()),
        alignment: 'left',
      });

      // Check if Overtime is Active
      if (this.empData.payOverTime) {
        this.doc.content.push({
          text: 'Overtime Active',
          alignment: 'left',
          bold: true,
          color: 'blue'
        });

        // Overtime Details
        this.doc.content.push({
          text: 'Overtime Starts After: ' + this.empData.startOverTime + ' Hr',
          alignment: 'left',
        });
        this.doc.content.push({
          text: 'Overtime Hours: ' + this.secondsToHms(this.overtimeHours),
          alignment: 'left',
        });
        this.doc.content.push({
          text: 'Overtime Rate: $' + this.empData.overTimeRate.toFixed(2),
          alignment: 'left',
        });

        // Overtime Pay
        this.doc.content.push({
          text: 'Overtime Pay: $' + this.overtimePay.toFixed(2),
          alignment: 'right',
        });
      }

      // Total Pay
      if (this.employeeAccess && this.employeeAccess.report.showPay) {
        this.doc.content.push({
          text: 'Regular Pay: $' + this.regularPay.toFixed(2),
          alignment: 'right',
        });

        // Show Total Pay (Regular + Overtime)
        this.doc.content.push({
          text: 'Total Pay: $' + this.totalPayWithOvertime.toFixed(2),
          alignment: 'right',
          bold: true,
          fontSize: 14
        });
      }

      // Time Clock Entries
      for (const date in this.unGroupList) {
        if (this.employeeAccess && this.employeeAccess.report.showHours) {
          this.doc.content.push({
            columns: [
              { text: date + ' - ' + this.$moment(date).format('dddd'), alignment: 'left' },
              { text: this.secondsToHms(this.unGroupList[date].totalInSeconds), alignment: 'right' },
            ],
            margin: [0, 20, 0, 5]
          });
        } else {
          this.doc.content.push({
            text: date + ' - ' + this.$moment(date).format('dddd'),
            alignment: 'left',
            margin: [0, 20, 0, 5]
          });
        }

        let timeClockHistory = [['IN', 'OUT', 'WORK']]
        this.unGroupList[date].row.map(item => {
          if (this.employeeAccess && this.employeeAccess.report.showHours) {
            if (item.clockOutTime)
              timeClockHistory.push([
                this.$moment(item.clockInTime).format('h:mm A').toString(),
                this.$moment(item.clockOutTime).format('h:mm A').toString(),
                this.secondsToHms(item.shiftDuration.totalInSeconds).toString()
              ]);
            else
              timeClockHistory.push([
                this.$moment(item.clockInTime).format('h:mm A').toString(),
                '-',
                this.secondsToHms(item.shiftDuration.totalInSeconds).toString()
              ]);
          } else {
            if (item.clockOutTime)
              timeClockHistory.push([
                this.$moment(item.clockInTime).format('h:mm A').toString(),
                this.$moment(item.clockOutTime).format('h:mm A').toString(),
                '-'
              ]);
            else
              timeClockHistory.push([
                this.$moment(item.clockInTime).format('h:mm A').toString(),
                '-',
                '-'
              ]);
          }
        });

        this.doc.content.push({
          table: {
            widths: [100, 100, '*'],
            body: timeClockHistory
          },
        });
      }

      // Generate PDF
      pdfMake.createPdf(this.doc).getDataUrl(data => {
        this.pdf = data;
      });
    },
    // async createDocument() {
    //   this.doc.content = []
    //   if (this.location) {
    //     this.doc.content.push({
    //       text: this.location.name,
    //       alignment: 'center',
    //       fontSize: 15,
    //     });
    //   }
    //   this.doc.content.push({
    //     text: "Time Card",
    //     alignment: 'center',
    //     fontSize: 15,
    //   });
    //   this.doc.content.push({
    //     text: this.empData.name,
    //     alignment: 'left',
    //     fontSize: 15,
    //   });
    //   this.doc.content.push({
    //     text: this.empData.phoneNumber,
    //     alignment: 'left',
    //   });
    //   if (this.employeeAccess && this.employeeAccess.report.showPay) {
    //     this.doc.content.push({
    //       text: 'Rate: $' + this.empData.hourlyRate,
    //       alignment: 'left',
    //     });
    //   }
    //   this.doc.content.push({
    //     text: 'From: ' + this.$moment(this.dateTime.start).format('ddd MM/DD/YYYY'),
    //     alignment: 'left',
    //   });
    //   this.doc.content.push({
    //     text: 'To: ' + this.$moment(this.dateTime.end).format('ddd MM/DD/YYYY'),
    //     alignment: 'left',
    //   });
    //   this.doc.content.push({
    //     text: 'Daily Working Hours: ' + this.workingHours + 'Hr',
    //     alignment: 'left',
    //   });
    //   if (this.employeeAccess && this.employeeAccess.report.showHours) {
    //     this.doc.content.push({
    //       text: 'Worked Hours ' + this.secondsToHms(this.totalSeconds),
    //       alignment: 'left',
    //     });
    //   }
    //   this.doc.content.push({
    //     text: 'Supposed To Work ' + this.secondsToHms(this.workingSeconds()),
    //     alignment: 'left',
    //   });
    //   if (this.employeeAccess && this.employeeAccess.report.showPay) {
    //     this.doc.content.push({
    //       text: 'Total Pay: $' + this.grandTotal_total.toFixed(2),
    //       alignment: 'right',
    //     });
    //   }
    //   for (const date in this.unGroupList) {
    //     if (this.employeeAccess && this.employeeAccess.report.showHours) {
    //       this.doc.content.push({
    //         columns: [
    //           { text: date + ' - ' + this.$moment(date).format('dddd'), alignment: 'left' },
    //           { text: this.secondsToHms(this.unGroupList[date].totalInSeconds), alignment: 'right' },
    //         ],
    //         margin: [0, 20, 0, 5]
    //       });
    //     } else {
    //       this.doc.content.push({
    //         text: date + ' - ' + this.$moment(date).format('dddd'),
    //         alignment: 'left',
    //         margin: [0, 20, 0, 5]
    //       });
    //     }
    //     let timeClockHistory = [['IN', 'OUT', 'WORK']]
    //     this.unGroupList[date].row.map(item => {
    //       if (this.employeeAccess && this.employeeAccess.report.showHours) {
    //         if (item.clockOutTime)
    //           timeClockHistory.push([this.$moment(item.clockInTime).format('h:mm A').toString(), this.$moment(item.clockOutTime).format('h:mm A').toString(), this.secondsToHms(item.shiftDuration.totalInSeconds).toString()])
    //         else
    //           timeClockHistory.push([this.$moment(item.clockInTime).format('h:mm A').toString(), '-', this.secondsToHms(item.shiftDuration.totalInSeconds).toString()])
    //       } else {
    //         if (item.clockOutTime)
    //           timeClockHistory.push([this.$moment(item.clockInTime).format('h:mm A').toString(), this.$moment(item.clockOutTime).format('h:mm A').toString(), '-'])
    //         else
    //           timeClockHistory.push([this.$moment(item.clockInTime).format('h:mm A').toString(), '-', '-'])
    //       }
    //     })
    //     this.doc.content.push(
    //       {
    //         table: {
    //           widths: [100, 100, '*'],
    //           body: timeClockHistory
    //         },
    //       },
    //     )
    //   }
    //   pdfMake.createPdf(this.doc).getDataUrl(data => {
    //     this.pdf = data;
    //   });
    // },
    backToReport() {
      this.$router.push({
        name: "hours-summary",
        params: { reload: this.reload },
      });
    },
    loadSetting() {
      authService.getLocation(this.locationCode).then((response) => {
        // console.log("response", response);
        response.data.Integrations.map((row) => {
          if (row.pubSubHook === "TERMINALTIMECLOCK") {
            this.integration = row;
            // console.log(row);
          }
        });
        if (response.data.metadata && response.data.metadata.customClockIn) {
          // console.log("in custom close in ");

          this.metadata = {
            ...this.metadata,
            ...response.data.metadata,
          };
        } else {
          if (this.integration) {
            this.metadata = {
              ...this.metadata,
              ...this.integration.LocationIntegration.metadata,
            };
          }
        }

        if (
          this.metadata.customClockIn &&
          this.metadata.customClockIn.defaultWorkingHours
        ) {
          this.workingHours = this.metadata.customClockIn.defaultWorkingHours;
        }
        // console.log(
        //   "this.integration.LocationIntegration.metadata",
        //   this.integration.LocationIntegration.metadata
        // );

        if (
          this.empData.metadata &&
          this.empData.metadata.timeClockLogin &&
          this.empData.metadata.timeClockLogin.workingHours
        ) {
          this.workingHours = this.empData.metadata.timeClockLogin.workingHours;
        }
        // this.metadata = {
        //   ...this.metadata,
        //   ...this.integration.LocationIntegration.metadata,
        // };
        // this.checkStatus();
      });
    },
    barColor(obj) {
      // :color="Object.entries(unGroupList)[i][1].astrid ? 'light-blue darken-1' : 'light-green darken-1'"
      // console.log('obj', obj)
      let value = "light-green darken-1";
      let totalSeconds = this.workingHours * 60 * 60;

      totalSeconds = this.workingHours * 60 * 60;
      if (obj.totalInSeconds < totalSeconds) {
        value = "red darken-1";
      }
      if (!obj.astrid && obj.totalInSeconds < totalSeconds) {
        obj.early = totalSeconds - obj.totalInSeconds;
      }

      if (obj.astrid) {
        value = "light-blue darken-1";
      }

      return value;
    },
    dataSave() {
      // this.snackbar.text = "Time entry saved";
      // this.snackbar.status = true;
      // this.snackbar.color = "black";
      // this.$toast.success("Time entry saved", { timeout: 2000 });
      this.reload = true;
      this.loadTimeClock();
      this.dialog = false;
    },
    savePayment() {
      this.$toast.success("Pay created!", { timeout: 2000 });
      this.loadTimeClock();
    },
    dataError(e) {
      console.log("errdataErrordataErroror", e);
      this.snackbar.text = "Can't save entry, check date and time";
      this.snackbar.status = true;
      this.snackbar.color = "error";
    },
    openDetail(row) {
      this.selectedRow = row;
      this.reload = true;
      this.dialog = true;
    },
    diffTime() {
      let value = this.workingSeconds() - this.totalSeconds;
      return value;
    },
    workingSeconds() {
      let value = this.workingHours;
      // if (
      //   this.empData.metadata &&
      //   this.empData.metadata.timeClockLogin &&
      //   this.empData.metadata.timeClockLogin.workingHours
      // ) {
      //   value = this.empData.metadata.timeClockLogin.workingHours;
      // }
      value *= Object.keys(this.unGroupList).length;
      // empData.metadata && empData.metadata.timeClockLogin && empData.metadata.timeClockLogin.workingHours
      let seconds = value * 60 * 60;
      return seconds;
    },
    secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor((d % 3600) / 60);
      var s = Math.floor((d % 3600) % 60);

      // console.log('AndDown', this.$vuetify.breakpoint.xsOnly)

      var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";

      if (this.$vuetify.breakpoint.xsOnly) {
        hDisplay = h > 0 ? h + " h, " : "";
        mDisplay = m > 0 ? m + " m, " : "";
        sDisplay = s > 0 ? s + " s " : "";
      }

      return hDisplay + mDisplay + sDisplay;
    },
    duration(seconds) {
      let value = 10;
      // let workingHours = 12;

      // if (
      //   metadata &&
      //   metadata.timeClockLogin &&
      //   metadata.timeClockLogin.workingHours
      // ) {
      //   workingHours = metadata.timeClockLogin.workingHours;
      // }

      const totalTime = this.workingHours * 60 * 60;
      // console.log('row', row, totalTime)
      value = (seconds / totalTime) * 100;
      return value;
    },
    loadTimeClock() {
      this.loading = true;
      this.showPayBtn = true;
      const dataObj = {
        start: this.dateTime.start,
        end: this.dateTime.end,
        EmployeeId: this.EmployeeId,
      };
      // console.log("dataObj", dataObj);
      return timeClockService
        .getEmployeeTimeClockReport(dataObj)
        .then((response) => {
          // console.log("loadTimeClock", response);
          this.totalSeconds = 0;
          this.unGroupList = _.mapValues(
            _.groupBy(response.data.timeClockList, (row) => {
              // console.log("row.TimeClockPayId", row.TimeClockPayId);
              if (row.TimeClockPayId) {
                this.showPayBtn = false;
              }
              return this.$moment(row.clockInTime).format("MM/DD/YYYY");
            }),
            (list) => {
              // console.log('printing list', list)
              // let newlist = []
              if (list.length > 1) {
                let seconds = 0;
                let astrid = false;
                list.map((row) => {
                  if (row.clockOutTime) {
                    seconds += row.shiftDuration.totalInSeconds;
                    this.totalSeconds += row.shiftDuration.totalInSeconds;
                  } else {
                    astrid = true;
                  }
                });
                // newlist.push({
                //     createdAt: list[0].createdAt,
                //     totalInSeconds: seconds
                // })
                return {
                  clockInTime: list[0].clockInTime,
                  astrid,
                  totalInSeconds: seconds,
                  metadata: list[0].Employee.metadata,
                  row: list,
                };
              } else {
                this.totalSeconds += list[0].shiftDuration.totalInSeconds;
                return {
                  id: list[0].id,
                  clockInTime: list[0].clockInTime,
                  astrid: list[0].clockOutTime ? false : true,
                  totalInSeconds: list[0].shiftDuration.totalInSeconds,
                  metadata: list[0].Employee.metadata,
                  row: list,
                };
              }
            }
          );

          this.timeClockList = response.data.timeClockList;
          this.totalTime = response.data.totalTime;
          this.count = this.timeClockList.length;
          if (!this.empData) {
            if (this.timeClockList.length > 1) {
              this.empData = this.timeClockList[0].Employee;
            }
          }
          this.createDocument()
          // console.log("this.unGroupList", this.unGroupList);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log("error is :", error);
        });
    },
  },
};
</script>

<style scoped>
.touch-view-container {
  height: calc(100vh - 350px);
  width: 100%;
  overflow: auto;
}

.touch-view-container-payDetail {
  height: calc(100vh - 325px);
  width: 100%;
  overflow: auto;
}
</style>
